<template>
    <b-modal :id="id" size="sm" v-model="alert_show" @ok="$emit('callback','ok')" @hide="$emit('callback','hide')">
        <p>{{ text }}</p>
        <template #modal-footer="{ ok, hide }">
            <b-button class="btn btn_md btn_gray" @click="hide" v-show="oneBtn">{{ btnLeft }}</b-button>
            <b-button :class="`btn btn_md ${className}`" @click="ok">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    export default {
        props: {
            id: String,
            text: String,
            btnLeft: String,
            btnRight: String,
            oneBtn: Boolean,
            isShow: Boolean,            
            msgId : String,
            closeEventValue : Boolean,
            className: {
                type: String,
                default: 'btn_blue'
            }
        },        
        data() {
            return {
                apply : false
            }
        },
        computed : {
            alert_show : {
                get() {
                    return this.isShow;    
                },
                set (newVal){                  
                    
                    //ok,hide보다 늦게 수행
                    this.$emit('update:showSetting', newVal);
                    
                    // console.log("@@@@ this.closeEventValue :"+ this.closeEventValue);
                    // console.log("@@@@ this.className :"+ this.className.type);
                    
                    if(this.closeEventValue == true){
                        // console.log("@@@@ alert modal close");
                        this.$emit('closeEvent');
                    }
                    
                }
            }
        },
        methods: {
        /**
         * 확인 버튼 클릭 시
         * @param {Function} ok - b-modal의 ok 함수
         */
        handleOk() {
            console.log("@@@ handleOk");
            ok(); // 모달 닫기


            // 특정 조건에서만 confirm 이벤트 emit
            // if (this.closeEvent == true) { // 예: apply가 true일 때만 이벤트
            //     this.$emit('closeEvent');
            // }

            // 다른 조건으로 원하는 조건 emit 처리 가능
            // if (this.text.includes('확인')) {
            //     this.$emit('confirm');
            // }
        },
        handleHide() {
            hide();
        }
    }
        
    }
</script>

<style>

</style>